import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchFilterData = async () => {
  const result = {
    patient: '',
    api: '',
    notification: '',
    payment: '',
    worker: '',
  }
  try {
    const response = await axios.get(
      `${Config.patientServerUrl.replace('/api/v1','')}/openapi.json`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    result.patient = response?.data?.info?.version;
  } catch (error) {
    result.patient = '';
  }
  
  try {
    const response = await axios.get(
      `${Config.apiServerUrl.replace('/api/v1','')}/openapi.json`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    result.api = response?.data?.info?.version;
  } catch (error) {
    result.api = '';
  }
  
  try {
    const response = await axios.get(
      `${Config.notificationServerUrl.replace('/api/v1','')}/openapi.json`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    result.notification = response?.data?.info?.version;
  } catch (error) {
    result.notification = '';
  }
  
  try {
    const response = await axios.get(
      `${Config.paymentServerUrl.replace('/api/v1','')}/openapi.json`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    result.payment = response?.data?.info?.version;
  } catch (error) {
    result.payment = '';
  }
  
  try {
    const response = await axios.get(
      `${Config.workerServerUrl.replace('/api/v1','')}/openapi.json`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    result.worker = response?.data?.info?.version;
  } catch (error) {
    result.worker = '';
  }

  return result;
};